import axios from 'axios';
import { AsyncSelect } from 'chakra-react-select';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';

function SelectGroupInput({ onChangeHandler }) {
  const loadGroups = debounce((inputValue, callback) => {
    axios
      .get(`/graph/groups?query=${inputValue.trim()}`)
      .then((response) => {
        callback(
          response.data?.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        );
      })
      .catch(() => {
        callback([]);
      });
  }, 1000);

  return (
    <AsyncSelect
      placeholder="Search by distribution list's name or email"
      loadOptions={loadGroups}
      onChange={(setter) => onChangeHandler(setter?.value)}
      isClearable
    />
  );
}

SelectGroupInput.propTypes = {
  onChangeHandler: PropTypes.func.isRequired,
};

export default SelectGroupInput;
